import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_BASE_HREF, CommonModule, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgSelectModule } from '@ng-select/ng-select';
import { PositionFilterPipe } from './position-filter.pipe';
import { ConfigurationService } from './service/configuration.service';
import { LoginComponent } from './components/login/login.component';
import { AuthenticationService } from './service/authentication.service';
import { TokenExpiredInterceptor } from './service/token-expired.interceptor';
import { PositionComponent } from './components/position/position.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { HeaderComponent } from './components/header/header.component';
import { MainComponent } from './components/main/main.component';
import { PositionResolver } from './service/position.resolver';
import { PathPrefixInterceptor } from './service/path-prefix.interceptor';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreModule } from '@ngrx/store';
import { applicationReducer } from '../store/Application/ApplicationReducer';
import { BaxterAuthModule } from '@baxter-jenkins/authenticator';
import { UpdateStaticInfoWidgetModule } from '@baxter-jenkins/update-static-info-widget';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { OrderModule, SpinnerInterceptor, TextMaskModule } from '@clearing-hub/angular-common';
import { AngularCommonModule } from '@clearing-hub/angular-common';

export function preloadProviderFactory(authenticationService: AuthenticationService) {
  return (): Promise<any> => authenticationService.loadUserInfoFromServer();
}

@NgModule({
  declarations: [
    AppComponent,
    PositionFilterPipe,
    LoginComponent,
    PositionComponent,
    HeaderComponent,
    MainComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    AngularCommonModule.forRoot({gridColumnsSize: 12}),
    HttpClientModule,
    NgxSpinnerModule.forRoot(),
    ToastrModule.forRoot({
      disableTimeOut: true
    }),
    BrowserAnimationsModule,
    TextMaskModule,
    NgSelectModule,
    TabsModule,
    ProgressbarModule,
    ModalModule.forRoot(),
    OrderModule,
    BsDropdownModule.forRoot(),
    BaxterAuthModule.forRoot({
      loginUrl: '/api/authentication/login',
      logoutUrl: '/api/authentication/signout',
      userPoolConfigUrl: '/api/authentication/user-pool',
      isRegistrationEnabled: true,
      registerUrl: '/api/authentication/register'
    }),
    UpdateStaticInfoWidgetModule.forRoot(),
    TooltipModule.forRoot(),
    StoreModule.forRoot({}),
    StoreDevtoolsModule.instrument({
      maxAge: 25
    }),
    StoreModule.forFeature('application', applicationReducer),
  ],
  providers: [
    DecimalPipe,
    {
      provide: APP_INITIALIZER,
      useFactory: preloadProviderFactory,
      deps: [AuthenticationService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PathPrefixInterceptor,
      multi: true,
    },
    {
      provide: APP_BASE_HREF,
      useValue: window['base-href']
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenExpiredInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true,
      deps: [
        NgxSpinnerService
      ]
    },
    ConfigurationService,
    PositionResolver
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
